const addDirectory = require("assets/icons/add_directory.svg").default;
const arrowPrev = require("assets/icons/G_D_btn___gallery_prev.svg").default;
const arrowNext = require("assets/icons/G_D_btn___gallery_succ.svg").default;
const settings = require("assets/icons/settings.png").default;

const icons = { addDirectory, arrowPrev, arrowNext, settings };

export default icons;
